import { render, staticRenderFns } from "./SaveSearchButton.vue?vue&type=template&id=64aa44fc&lang=pug"
import script from "./SaveSearchButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SaveSearchButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports